// Copyright 2024, 2026 - Hewlett Packard Enterprise Company
function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

/*
 *
 * buttons and menus should set the href prop and use the onClick handler such as:
 *
 * <Button
 *   href={url}
 *   onClick={(event) => {
 *     handleNavClick(event, (event) => {
 *       history.push(url);
 *     })
 *   }}
 * />
 *
 * We should re-evaluate this pattern to use next.js' <Link> component instead if/when
 * we migrate to next.js.  These handlers cherry pick functionality from react-router's
 * useLinkClickHandler hook, which aims to maintain the single page app (SPA) navigation
 * but provide more of a native navigation experience.
 * https://github.com/remix-run/react-router/blob/main/packages/react-router-dom/dom.ts#L32C2-L32C2
 *
 * semantically there should be only one interactive element (an anchor tag with a href),
 * and clicking it should be handled by the SPA internal router unless the user is
 * pressing a modifer key.  This balances different aspects of good user experience-
 * not reloading the full application on every navigation, and allowing them to open
 * routable links in new tabs/windows.
 *
 */
export const handleNavClick = (event, callback) => {
  if (
    event.button === 0 && // Ignore everything but left clicks
    !isModifiedEvent(event) // Ignore clicks with modifier keys
  ) {
    event.preventDefault();
    callback(event);
  }
};
